module.exports = __webpack_public_path__ + "img/9791188810628.b92fef21.jpg";